export default "__VITE_ASSET__Jiy1uRmu__"